export const useAdBodyClass = (type: string, dataPosition: string, enabled = true) => {
  useEffect(() => {
    if (!enabled || dataPosition !== "position-01") {
      return;
    }

    const className = `bd-ad-${type}`;
    document.body.classList.add(className);

    return () => {
      document.body.classList.remove(className);
    };
  }, [dataPosition, enabled, type]);
};
